import PropTypes from "prop-types";
import { schema, availableSizes, sizeClasses } from "./Badge.styles";

const getFormattedValue = (value, size) => {
  if (size === "medium") {
    return value > 99 ? "99+" : value;
  }

  return value > 9 ? "9+" : value;
};

const Badge = ({ value, size, className, ...otherProps }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <div className={`${schema.regular} ${sizeClasses(size)} ${className}`} {...otherProps}>
    {getFormattedValue(value, size)}
  </div>
);

Badge.propTypes = {
  value: PropTypes.number,
  size: PropTypes.oneOf(availableSizes),
  className: PropTypes.string,
};

Badge.defaultProps = {
  value: 0,
  size: "small",
  className: "",
};

export default Badge;
